import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CategoryTabs = ({ 
  categories, 
  activeCategory, 
  onCategoryChange, 
  officeCounts = {},
  searchQuery,
  onSearchChange,
  className = '' 
}) => {
  const getCategoryIcon = (categoryId) => {
    switch (categoryId) {
      case 'board':
        return 'Users';
      case 'supervisory':
        return 'Shield';
      case 'electoral':
        return 'Vote';
      case 'general_assembly':
        return 'Users';
      case 'offices':
        return 'Briefcase';
      default:
        return 'Folder';
    }
  };

  const getCategoryLabel = (categoryId) => {
    switch (categoryId) {
      case 'board':
        return 'مجلس الإدارة';
      case 'supervisory':
        return 'الهيئة الإشرافية';
      case 'electoral':
        return 'اللجنة الانتخابية';
      case 'general_assembly':
        return 'الهيئة العمومية';
      case 'offices':
        return 'المكاتب';
      default:
        return categoryId;
    }
  };

  return (
    <div className={`bg-card border border-border rounded-lg p-4 ${className}`}>
      {/* Search Bar */}
      <div className="mb-4">
        <div className="relative">
          <Icon 
            name="Search" 
            size={18} 
            className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground" 
          />
          <input
            type="text"
            placeholder="البحث في المناصب..."
            value={searchQuery}
            onChange={(e) => onSearchChange(e?.target?.value)}
            className="w-full pl-10 pr-4 py-2 bg-background border border-border rounded-lg text-sm text-foreground placeholder-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
          />
        </div>
      </div>
      {/* Category Tabs */}
      <div className="flex flex-wrap gap-2">
        {categories?.map((category) => {
          const isActive = activeCategory === category?.id;
          const count = officeCounts?.[category?.id] || 0;
          
          return (
            <Button
              key={category?.id}
              variant={isActive ? 'default' : 'ghost'}
              size="sm"
              onClick={() => onCategoryChange(category?.id)}
              className={`flex items-center space-x-2 ${
                isActive 
                  ? 'bg-primary text-primary-foreground' 
                  : 'text-muted-foreground hover:text-foreground hover:bg-muted'
              }`}
            >
              <Icon name={getCategoryIcon(category?.id)} size={16} />
              <span className="font-medium">{getCategoryLabel(category?.id)}</span>
              {count > 0 && (
                <span className={`inline-flex items-center justify-center w-5 h-5 text-xs font-medium rounded-full ${
                  isActive 
                    ? 'bg-primary-foreground text-primary' 
                    : 'bg-muted text-muted-foreground'
                }`}>
                  {count}
                </span>
              )}
            </Button>
          );
        })}
      </div>
      {/* Category Description */}
      {activeCategory && (
        <div className="mt-4 p-3 bg-muted/50 rounded-lg">
          <p className="text-sm text-muted-foreground">
            {activeCategory === 'board' && 'إدارة أعضاء مجلس الإدارة والمناصب التنفيذية'}
            {activeCategory === 'supervisory' && 'إدارة أعضاء الهيئة الإشرافية والرقابية'}
            {activeCategory === 'electoral' && 'إدارة أعضاء اللجنة الانتخابية والعمليات الانتخابية'}
            {activeCategory === 'general_assembly' && 'إدارة أعضاء الهيئة العمومية'}
            {activeCategory === 'offices' && 'إدارة المكاتب والأقسام الإدارية المختلفة'}
          </p>
        </div>
      )}
    </div>
  );
};

export default CategoryTabs;